import { TableFilters } from '@shared/ui/DataTable/table-filters';
import { userFiltersConfig, initialValues } from './constants';

type UserListFiltersProps = {
  pageSize?: number;
  setFilter: (filter: any) => void;
};

export const UserListFilters = ({
  setFilter,
  pageSize,
}: UserListFiltersProps) => {
  return (
    <TableFilters
      config={userFiltersConfig}
      initialValues={initialValues}
      setFilter={setFilter}
      pageSize={pageSize}
    />
  );
};
